import { withPreRenderSettings } from '@/utils/hocs';
import { BusinessLandingPageView } from '@/views/BusinessPage/BusinessPage.view';
import { getServerPackagesList } from '@/api/helpers/business.helpers';
import type { PackagesListData } from '@/api/types/business.types';
import { getHostFromReq, getLangFromHost, makeHostSum } from '@/utils/helpers';
import { getServerI18n } from '@/i18n-server';
import type { SeoFullData } from '@/api/types/seo.types';

interface Props {
  isLite?: boolean;
  packagesListData?: PackagesListData | null;
}

function BusinessViewPage({ isLite, packagesListData }: Props) {
  return (
    <BusinessLandingPageView
      isLite={isLite}
      packagesListData={packagesListData}
    />
  );
}

BusinessViewPage.getInitialProps = withPreRenderSettings(
  async (context, client) => {
    const query = context?.query ?? {};
    const isLite = String(query?.app ?? '') === '1';
    const packagesListData = await getServerPackagesList(client, context);

    const host = context.req ? getHostFromReq(context.req) : '';
    const currentLang = getLangFromHost(host);
    const i18n = getServerI18n(currentLang);
    const hostSum = makeHostSum({
      asPath: context.asPath ?? context.req?.url,
      req: context.req,
    });
    const seoFullData: SeoFullData = {
      title: i18n.t('business.seo.title'),
      ogTitle: i18n.t('business.seo.title'),
      description: i18n.t('business.seo.description'),
      hostSum,
    };

    return {
      isLite,
      packagesListData: packagesListData ?? null,
      seoFullData,
    };
  }
);

export default BusinessViewPage;
